import { render, staticRenderFns } from "./InProgressSection.vue?vue&type=template&id=4a61a3a3&scoped=true&"
import script from "./InProgressSection.vue?vue&type=script&lang=js&"
export * from "./InProgressSection.vue?vue&type=script&lang=js&"
import style0 from "./InProgressSection.vue?vue&type=style&index=0&id=4a61a3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a61a3a3",
  null
  
)

/* custom blocks */
import block0 from "./InProgressSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports